module.exports = "<s-featured-list v-bind=\"$attrs\" :featureds=\"featureds\" @click=\"onFeaturedClik\" />\n\n"